export default {
  /* A */
  add: 'Adicionar',
  all: 'Todos',
  admin: 'Painel de Administração',
  alias: 'Alias',
  apply: 'Aplicar',
  agent: 'Agente',
  agents: 'Agentes',
  appKey: 'Nome de Usuário',
  avatar: 'Avatar',
  amount: 'Montante',
  action: 'Ação',
  agentId: 'ID do Agente',
  approve: 'Aprovar',
  activate: 'Ativar',
  autoSync: 'Sincronização Automática',
  approval: 'Aprovação',
  approved: 'Aprovado',
  allCache: 'Todos os Caches',
  activated: 'Ativado',
  accountId: 'ID do Usuário do Sistema de Transações',
  appSecret: 'Senha',
  agentName: 'Nome do Agente',
  amountInfo: 'Informação do Montante',
  addressInfo: 'Informação do Endereço',
  autoChannel: 'Canal Automático',
  addressDetail: 'Detalhes do Endereço',
  accountAmount: 'Montante da Conta',
  approvalStatus: 'Status de Aprovação',
  accountCurrency: 'Moeda da Conta',
  alreadyLoggedIn: 'Já Conectado',
  approvalProcess: 'Processo de Aprovação',
  accountActivate: 'Ativar Conta',
  accountActivated: 'Conta Já Ativada',
  appliedDate: 'Data de Aplicação',
  approvalComment: 'Comentário de Aprovação',
  approveAndWithdraw: 'Aprovar e Retirar',
  alreadyHaveAccount: 'Já Possui Conta?',
  // accountRiskLevel: 'Nível de Risco da Conta',
  allSelectedCount: 'Tudo ({count})',
  actualAccountAmount: 'Montante Real da Conta',
  actualDepositAmount: 'Montante de Depósito Real',
  accountDepositAmount: 'Montante de Depósito na Conta',
  accountWithdrawalAmount: 'Montante de Retirada',
  apiResultMsg: 'Mensagem de Resultado API',
  android: 'Android',
  androidLink: 'Link Android',
  accountInfo: 'Informação da Conta',

  /* B */
  back: 'Voltar',
  bank: 'Banco',
  branch: 'Filial',
  backTo: 'Voltar para Login',
  bankNo: 'Número do Banco',
  backTop: 'Voltar ao Topo',
  balance: 'Saldo',
  bankCard: 'Cartão Bancário',
  bordered: 'Bordado',
  basicInfo: 'Informação Básica',
  batchSize: 'Tamanho do Lote',
  backToLogin: 'Voltar',
  backToPrevious: 'Voltar para Anterior',
  backToPreviousStep: 'Passo Anterior',
  backToRegister: 'Voltar',
  bankBranch: 'Nome da Agência Bancária',
  bankAccount: 'Conta Bancária',
  baseCurrency: 'Moeda Base',
  branchAddress: 'Endereço da Filial',
  bankAccountName: 'Nome da Conta Bancária',
  bankNameOrNetwork: 'Nome do Banco / Rede de Depósito',
  bankCardInfo: 'Informações do Cartão Bancário',
  bankCardId: 'ID do Cartão Bancário',

  /* C */
  csv: 'CSV',
  copy: 'Copiar',
  check: 'Verificar',
  close: 'Fechar',
  cancel: 'Cancelar',
  create: 'Criar',
  confirm: 'Confirmar',
  checked: 'Verificado',
  comment: 'Comentário',
  countryOrRegion: 'País / Região',
  created: 'Criado',
  channel: 'Canal',
  closeAll: 'Fechar Tudo',
  customer: 'Cliente',
  copyLink: 'Copiar Link',
  countries: 'Países',
  createdBy: 'Criado por',
  childType: 'Tipo Secundário',
  cancelDate: 'Data de Cancelamento',
  cardholder: 'Titular do Cartão',
  customerId: 'ID do Cliente',
  configName: 'Nome da Variável',
  configDesc: 'Descrição da Variável',
  cardDetail: 'Detalhes do Cartão',
  conversion: 'Conversão',
  cashflowKid: 'ID do Fluxo de Caixa do Sistema de Transações',
  channelName: 'Nome do Canal',
  configValue: 'Valor da Variável',
  createdDate: 'Data de Criação',
  currencyType: 'Tipo de Moeda',
  channelError: 'Erro no Canal',
  customerInfo: 'Informação do Cliente',
  customerData: 'Dados do Cliente',
  currentCache: 'Cache Atual',
  closeAllTabs: 'Fechar Todas as Abas',
  createdBefore: 'Criado Antes',
  cryptoNetwork: 'Rede de Depósito',
  clearAllCache: 'Limpar Todo o Cache',
  contactContent: 'Conteúdo de Contato',
  forgotPassword: 'Esqueceu a Senha',
  changePassword: 'Alterar Senha',
  customerVerify: 'Verificação do Cliente',
  closeOtherTabs: 'Fechar Outras Abas',
  closeRightTabs: 'Fechar Abas à Direita',
  createAccounts: 'Criar Contas',
  certificateNo: 'Número de Certidão',
  confirmationMin: 'Mínimo de Confirmações',
  confirmPassword: 'Confirmar Senha',
  closeCurrentTab: 'Fechar Aba Atual',
  chineseSimplified: 'Chinês Simplificado',
  changePwdSucceess: 'Senha Alterada com Sucesso',
  customerFeeAmount: 'Montante da Taxa do Cliente',
  customerCurrencies: 'Moedas do Cliente',
  customerDepositFlow: 'Fluxo de Depósito do Cliente',
  customerVerifyFlowId: 'ID Atual de Verificação do Cliente',
  customerIdentificationId: 'ID de Identificação do Cliente',
  cancelTransaction: 'Cancelar Transação',
  cancelTransactionPopupTitle: 'Essa ação não pode ser desfeita. Tem certeza de que deseja cancelar esta transferência?',
  captchaImageErrorMsg: 'Erro ocorreu, clique em mim para recarregar',
  captchaText: 'Código de Verificação',
  completed: 'Concluído',
  confirmDetail: 'Detalhes da Confirmação',
  confirmProof: 'Comprovante de Confirmação',
  confirmComplete: 'Confirmação Concluída',
  confirmRecvPopupTitle: 'Essa ação não pode ser desfeita. Por favor, confirme que você recebeu essa transferência.',
  confirmTransaction: 'Confirmar Transação',
  confirmTransactionPopupTitle: 'Essa ação não pode ser desfeita. Tem certeza de que concluiu esta transferência?',
  currentChannelNotAvailableAndSetAsAuto: 'Canal atual não disponível, mudado para Automático',

  /* D */
  dob: 'Data de Nascimento',
  desc: 'Descrição',
  detail: 'Detalhe',
  details: 'Detalhes',
  deposit: 'Depositar',
  depositHistory: 'Histórico de Depósitos',
  download: 'Baixar',
  demoSystem: 'Sistema de Demonstração',
  demoAppKey: 'Nome de Usuário de Demonstração',
  description: 'Descrição',
  demoAppSecret: 'Senha de Demonstração',
  depositAmount: 'Valor do depósito',
  depositDetail: 'Detalhes do Depósito',
  depositVerify: 'Verificação de Depósito',
  depositRemark: 'Mensagem de Transferência',
  depositFlowId: 'ID de Depósito',
  depositCurrency: 'Moeda de Depósito',
  depositApproval: 'Aprovação de Depósito',
  depositInfo: 'Informação de Depósito',

  /* E */
  en: 'Inglês',
  env: 'Ambiente',
  edit: 'Editar',
  enum: 'Enumeração',
  empty: 'Vazio',
  enable: 'Ativar',
  enabled: 'Ativado',
  existing: 'Existente',
  equalZero: 'Igual a Zero',
  expandAll: 'Expandir Tudo',
  emailDetail: 'Detalhes do E-mail',
  engFullName: 'Nome Completo em Inglês',
  engShortName: 'Nome Curto em Inglês',
  emailVerified: 'E-mail Verificado',
  encryptedId: 'ID do Comerciante de Cima',
  expectedWithdrawalAmount: 'Montante de Retirada Esperado',
  exclusiveAccountId: 'ID da Conta de Agente Exclusiva',

  /* F */
  fee: 'Taxa',
  force: 'Forçar',
  fxRate: 'Detalhes da Taxa de Câmbio',
  failure: 'Falha',
  feeInfo: 'Informações da Taxa',
  flowInfo: 'Informações do Fluxo',
  fullName: 'Nome Completo',
  forceCancel: 'Cancelar Forçadamente',
  familyNameEn: 'Sobrenome',
  forceConfirm: 'Confirmar Forçadamente',
  frozenAmount: 'Montante Congelado',
  fxCurrencyPair: 'Par de Moedas de Câmbio Estrangeiro',
  fxRateTemplate: 'Modelo de Taxa de Câmbio FX',
  fatcaSignedDate: 'Data da Assinatura FATCA',
  fxRateTemplateId: 'ID do Modelo de Taxa de Câmbio FX',
  forgotNoticeTitle1: 'O link para redefinir a senha foi enviado para o seu e-mail',
  forgotNoticeTitle2: 'Por favor, verifique o seu e-mail!',
  forgotNoticeTitle3: 'Já verificou o seu e-mail e clicou no link?',

  /* G */
  goRegister: 'Registre-se Agora',
  gotoVerify: 'Ir para a Verificação',
  goDeposit: 'Ir para o Depósito',
  goLogin: 'Por favor, acesse a plataforma do aplicativo para fazer login',
  giinTaxNo: 'Número de Identificação Fiscal GIIN',
  givName: 'Nome',
  guestForbidden: 'Desabilitar login de convidado',
  givenNameEn: 'Nome',
  greaterThan: 'Maior que {number}',
  greaterThanZero: 'Maior que Zero',
  gatewayLoginUsername: 'Nome de Usuário de Login na Plataforma',
  gatewayFeeAmount: 'Montante Estimado da Taxa de Plataforma',

  /* H */
  hide: 'Ocultar',
  help: 'Ajuda',
  hours: 'Horas',
  hasRemainingAmount: 'Tem Montante Restante',

  /* I */
  id: 'ID',
  it: 'Instituição',
  itId: 'ID da Instituição',
  items: 'Itens',
  itName: 'Nome da Instituição',
  inviter: 'Convidado',
  identity: 'Identidade',
  itReceive: 'Conta de Depósito',
  invalidUrl: 'URL Inválido',
  inputAmount: 'Digite o Montante',
  inputPaymentInfo: 'Informações de Pagamento',
  inputPaymentMethod: 'Método de Cálculo de Montante',
  itReceiveAccount: 'Conta de Recebimento da Instituição',
  itReceiveId: 'ID da Conta de Recebimento da Instituição',
  internetUser: 'Usuário de Internet',
  institutionId: 'ID da Instituição',
  identifyDetail: 'Detalhes da Identificação',
  identification: 'Identificação',
  identityVerify: 'Verificação de Identidade',
  itReceiveMethod: 'Método de Recebimento da Instituição',
  itReceiveNumber: 'Número da Conta de Recebimento da Instituição',
  identificationId: 'ID de Identificação',
  identificationType: 'Tipo de Documento de Identificação',
  identificationInfo: 'Informações de Identificação',
  identificationNumber: 'Número de Documento de Identificação',
  identificationStep1Title: 'Informações Pessoais',
  identificationStep1Name: 'Por favor, digite o seu nome exatamente como aparece no seu documento de identidade (em pinyin)',
  identificationStep2OnlyTaxInCountry: 'Eu só pago impostos nos países mencionados anteriormente',
  identificationStep2SameBirthNationality:
    'O meu local de nascimento e nacionalidade correspondem aos países mencionados anteriormente',
  identificationStep2NonUSResident: 'Não sou cidadão dos EUA nem residente tributário nos EUA',
  identificationStep4Title: 'Conhecimento de Investimento',
  identificationStep4Desc:
    'Precisamos avaliar o seu conhecimento sobre produtos financeiros. Respostas incorretas podem resultar em falha na avaliação. Por favor, pense cuidadosamente sobre as suas respostas.',
  identificationStep4KlMaxInvestment:
    'Você investiu $3,000. Qual é o valor máximo da posição que você pode negociar com uma alavancagem de 1:100 (usando alavancagem)?',
  identificationStep4KlTrigger: 'Se uma ordem de stop loss for acionada',
  identificationStep4KlAutoClose:
    'Minha posição não fechada pode ser fechada automaticamente nas seguintes condições (por exemplo, margem adicional)',
  identificationStep5Title1: 'Avaliação de Adequação',
  identificationStep5Title2: 'Experiência de Negociação',
  identificationStep5Desc:
    'Precisamos avaliar o seu conhecimento sobre produtos financeiros. Respostas incorretas podem resultar em falha na avaliação. Por favor, pense cuidadosamente sobre as suas respostas.',
  identificationStep5AxTradingCount:
    'Que tipos de experiência de negociação você teve nos últimos 12 meses (sem conselhos profissionais)? Ações, títulos, commodities',
  identificationStep5AxOtcCount: 'Instrumentos financeiros fora da bolsa (CFDs alavancados, forex, spread betting)',
  identificationStep5AxOtcLeverage:
    'Em média, qual é a alavancagem utilizada para negociar os instrumentos financeiros fora da bolsa mencionados acima?',
  identificationStep6Title: 'Experiência Profissional',
  identificationStep6ExpHasFinanceEducation:
    'Nos últimos 3 anos, você obteve educação, qualificações profissionais e/ou experiência de trabalho no setor de serviços financeiros (envolvendo negociação alavancada)?',
  identificationStep6ExpFinanceEducation:
    'Por favor, forneça mais informações sobre a sua educação, qualificações profissionais e/ou experiência de trabalho no setor de serviços financeiros',
  identificationStep7Title: 'Emprego',
  identificationStep7Occupation: 'Qual é a sua situação profissional?',
  identificationStep7Industry: 'Em que setor você trabalha?',
  identificationStep8Title: 'Informações Financeiras',
  identificationStep8finAnnualIncome: 'Rendimento anual',
  identificationStep8finSavingsInvestment: 'Poupança e investimento (excluindo propriedade)',
  identificationStep8finIncomeSource: 'Principal fonte de fundos de negociação',
  identificationStep8maxInvestmentLoss:
    'Qual é o montante aproximado de perdas de investimento que você pode suportar anualmente?',
  identificationStep9Title: 'Perfil de Negociação',
  identificationStep9TradingFrequency: 'Com que frequência você planeia negociar?',
  identificationStep9DepositMethod: 'Como planeia financiar a sua conta?',
  identificationStep9AcknowledgeTradingRisk:
    'Compreendo e concordo que a natureza das transações que realizo com a {name} é a compra e venda de Contratos por Diferença (CFDs) de ativos subjacentes. Compreendo que a negociação de CFDs não é adequada para todos e apenas pessoas com uma alta tolerância ao risco devem negociar.',
  identificationStep10Title: 'Termos e Condições',
  identificationStep10ConsentAgreement: 'Li e concordo com os Termos de Uso da {name}',
  identificationStep10Agreement1: 'Política de Execução de Ordens',
  identificationStep10Agreement2: 'Divulgação de Risco',
  identificationStep10Agreement3: 'Política de Privacidade',
  identificationStep10Agreement4: 'Documento de Informações Essenciais',
  isExclusive: 'Agente Exclusivo',
  ios: 'iOS',
  iosLink: 'Link iOS',
  ifsc: 'Chave IFSC',

  /* J */
  jurisdiction: 'Jurisdição',

  /* K */
  kv: 'Versão do Registro do Sistema de Negociação',
  key: 'Chave',

  /* L */
  list: 'Lista',
  lock: 'Bloquear',
  line1: 'Endereço 1',
  line2: 'Endereço 2',
  login: 'Login',
  logout: 'Sair',
  locked: 'Bloqueado',
  loginId: 'ID de Login',
  language: 'Idioma',
  lockTime: 'Tempo de Bloqueio',
  liveSystem: 'Sistema em Tempo Real',
  loginQuick: 'Login Rápido',
  loginUsername: 'Digite seu endereço de e-mail',
  loginPassword: 'Digite sua senha de login',
  lastModifiedBy: 'Última Modificação por',
  lastModifiedDate: 'Data de Última Atualização',
  lastAutoSyncTime: 'Hora de Sincronização Automática',
  lookBackInterval: 'Intervalo de Retrocesso',
  localDepositAmount: 'Valor do Depósito Local',

  /* M */
  mark: 'Marcar',
  more: 'Mais',
  mobile: 'Celular',
  minute: 'Minuto',
  minutes: 'Minutos',
  merchantName: 'Nome do Comerciante',
  middleNameEn: 'Nome do Meio',
  mobileDetail: 'Celular',
  manualRefresh: 'Atualização Manual',
  myReceiveAccount: 'Minha Conta de Recebimento',
  myReceiveBank: 'Meu Banco de Recebimento',
  myReceiveNumber: 'Meu Número de Conta de Recebimento',
  maxAutoConfirmAmount: 'Valor Máximo de Confirmação Automática',
  minTransactionAmount: 'Valor Mínimo de Transação Única',
  maxTransactionAmount: 'Valor Máximo de Transação Única',
  macX86Desktop: 'Mac(x86) Desktop',
  macX86DesktopLink: 'Link do Aplicativo de Mesa Mac (x86)',
  macArmDesktop: 'Mac(Arm) Desktop',
  macArmDesktopLink: 'Link do Aplicativo de Mesa Mac (Arm)',

  /* N */
  no: 'Não',
  name: 'Nome',
  number: 'Número',
  notEnabled: 'Não Ativado',
  notifyLang: 'Idioma de Notificação',
  notNecessary: 'Não Necessário',
  networkUrls: 'URLs de Rede',
  newPassword: 'Nova Senha',
  neverExpire: 'Nunca Expira',
  noDataFound: 'Nenhum Dado Encontrado',
  notifyEmail: 'E-mail de Notificação',
  nextStep: 'Próxima Etapa',
  noAccount: 'Sem Conta?',
  noTransactionHint: 'Nenhuma Transação Encontrada, Por Favor, Aguarde',
  noAvailableChannel: 'Nenhum Canal Disponível, Tente Novamente Mais Tarde',

  /* O */
  on: 'Ligado',
  or: 'Ou',
  off: 'Desligado',
  operator: 'Operador',
  oldPassword: 'Senha Antiga',

  /* P */
  px: 'Pixels',
  proof: 'Comprovante',
  people: 'Pessoas',
  profile: 'Perfil',
  process: 'Processar',
  payType: 'Tipo de Pagamento',
  pageSize: 'Tamanho da Página',
  province: 'Província',
  password: 'Senha',
  postCode: 'Código Postal',
  processed: 'Processado',
  processes: 'Processos',
  profession: 'Profissão',
  plzRelogin: 'Por Favor, Faça Login Novamente',
  phoneDetail: 'Telefone Fixo',
  parentAgent: 'Agente Responsável',
  preconditions: 'Condições Prévias',
  paymentChannel: 'Canal de Pagamento',
  paymentGateway: 'Gateway de Pagamento',
  paymentRouting: 'Roteamento de Pagamento',
  processComplete: 'Processo Concluído',
  paymentRoutingId: 'ID de Roteamento de Pagamento',
  passwordResetNoticeTitle: 'Senha Alterada com Sucesso',
  passwordResetFailTitle: 'Redirecionar para',
  paymentCurrency: 'Moeda de Pagamento',
  pleaseChooseItReceiveAccount: 'Escolha a Conta de Recebimento',
  pleaseChoosePayment: 'Escolha o Método de Pagamento',
  pleaseSignIn: 'Por Favor, Insira seu Nome de Usuário e Senha',
  pleaseSignUp: 'Por Favor, Insira o Nome de Usuário e a Senha para Registrar',
  pleaseVerifySoon: 'Por Favor, Complete a Verificação Rapidamente',
  previousStep: 'Etapa Anterior',
  planDepositAmount: 'Receberá Fundos',
  paymentFeeModel: 'Modelo de Taxa de Pagamento',
  paymentFeeValue: 'Valor Definido da Taxa de Pagamento',
  paymentFeeCurrency: 'Moeda da Taxa de Pagamento',
  plzReloginWithNewPwd: 'Por Favor, Faça Login com a Nova Senha',
  paymentFeeInfo: 'Informações da Taxa de Pagamento',
  paymentOrderStatus: 'Status do Pedido de Pagamento',
  providerType: 'Tipo de Registro',
  pleaseSelectApprovalStatus: 'Por Favor, Selecione o Status de Aprovação',
  paymentFeeAmount: 'Valor Estimado da Taxa de Pagamento',
  processing: 'Processando',
  pixType: 'Tipo de Pix',
  pixKey: 'Chave Pix',

  /* Q */
  qrCode: 'Código QR',
  quoteCurrency: 'Moeda de Cotação',

  /* R */
  rate: 'Taxa',
  role: 'Função',
  roles: 'Funções',
  reset: 'Reiniciar',
  region: 'Região',
  result: 'Resultado',
  roleId: 'Função',
  remove: 'Remover',
  reject: 'Rejeitar',
  reason: 'Motivo',
  receive: 'Receber',
  refresh: 'Atualizar',
  retract: 'Retrair',
  regDate: 'Data de Registro',
  register: 'Registrar',
  receiver: 'Receptor',
  resource: 'Recurso',
  retryMail: 'Reenviar E-mail',
  resend: 'Reenviar',
  receiverId: 'ID do Receptor',
  refreshAll: 'Atualizar Tudo',
  regCustomer: 'Registro de Cliente',
  rateDetails: 'Detalhes da Taxa',
  receiverName: 'Nome do Receptor',
  receiverRole: 'Função do Receptor',
  receiveMethod: 'Método de Recebimento',
  receiveNumber: 'Número da Conta',
  receiverNumberCpf: 'Número da Conta',
  receiverNumberPhone: 'número de telefone',
  receiverNumberEmail: 'E-mail',
  receiverNumberEvp: 'Endereço Virtual de Pagamento',
  resetPassword: 'Redefinir Senha',
  receiverNumber: 'Número do Receptor',
  receiverAccount: 'Conta do Receptor',
  receiveCurrency: 'Moeda de Recebimento',
  receiverNetwork: 'Rede de Recebimento',
  remainingAmount: 'Valor Restante',
  recoverPassword: 'Recuperar Senha',
  receivingCurrency: 'Moeda de Recebimento',
  registerNoAgentAlert: 'Por Favor, Contate o Agente para Obter o Link de Registro',
  registerNoticeTitle: 'Após Ativar sua Conta por E-mail,',
  registerVerifyTitle1: 'Registro Bem Sucedido!',
  registerVerifyTitle2: 'Por Favor, Faça Login Novamente',
  resendActiveMail: 'Reenviar E-mail de Ativação',
    recoverMailPassword: 'Por Favor, Insira o E-mail para Recuperar a Senha',
    recoverPhonePassword: 'Por favor insira o número do seu celular para recuperar sua senha',


  restoreDefaultSettings: 'Restaurar Configurações Padrão',
  receiverNumberOrAddress: 'Número ou Endereço do Receptor',
  registerOtherWay: 'Ou Registre-se de Outra Forma',
  registerAgreementTitle1: 'Eu Li e Aceito os',
  registerAgreementTitle2: 'Termos de Uso',
  registerPleaseAgree: 'Por favor, concorde com os termos de usuário',

  /* S */
  sex: 'Sexo',
  show: 'Mostrar',
  step: 'Etapa',
  sync: 'Sincronizar',
  send: 'Enviar',
  synced: 'Sincronizado',
  source: 'Origem',
  status: 'Status',
  search: 'Pesquisar',
  sender: 'Remetente',
  social: 'Social',
  signUp: 'Registrar',
  stopHinting: 'Parar de Sugerir',
  submit: 'Enviar',
  surName: 'Sobrenome',
  setting: 'Configuração',
  success: 'Sucesso',
  settings: 'Configurações',
  senderId: 'ID do Remetente',
  secretKey: 'Chave Secreta',
  selectAll: 'Selecionar Tudo',
  superUser: 'Super Usuário',
  shortName: 'Nome Curto',
  searchKey: 'Chave de Pesquisa',
  shareCode: 'Código de Compartilhamento',
  subAgents: 'Subagentes',
  syncAgent: 'Sincronizar Agente',
  senderRole: 'Função do Remetente',
  signedDate: 'Data de Assinatura',
  socialDetail: 'Detalhes Sociais',
  signedStatus: 'Status de Assinatura',
  successMin: 'Mínimo de Sucesso',
  systemConfig: 'Configuração do Sistema',
  selectedCount: 'Selecionados ({count})',
  systemFeeModel: 'Modelo de Taxa do Sistema',
  systemFeeValue: 'Valor da Taxa do Sistema',
  syncInstitution: 'Sincronizar Instituição',
  settlementCurrency: 'Moeda de Liquidação',
  statusInfo: 'Informações de Status',

  /* T */
  tw: 'Chinês Tradicional',
  tabs: 'Guias',
  type: 'Tipo',
  table: 'Tabela',
  token: 'Token',
  total: 'Total',
  target: 'Alvo',
  taxNo: 'Número de Identificação Fiscal',
  txHash: 'Hash de Transação',
  toRefId: 'ID da Conta de Recebimento do Cliente',
  tabLimit: 'Limite de Abas',
  transfer: 'Transferência',
  tinTaxNo: 'Número de Identificação Fiscal',
  toRefBank: 'Banco de Recebimento do Cliente',
  testNetwork: 'Rede de Teste',
  tax: 'Imposto',
  taxDetail: 'Detalhes do Imposto',
  taxFormType: 'Tipo de Formulário Fiscal',
  taxFormDate: 'Data do Formulário Fiscal',
  taxNoExpireDate: 'Data de Expiração do Número de Identificação Fiscal',
  transaction: 'Transação',
  transactionProof: 'Comprovante de Transação',
  tronScanUrl: 'URL do Tron Scan',
  toRefNumber: 'Número da Conta do Cliente de Recebimento',
  timedRefresh: 'Atualização Agendada',
  tokenExpired: 'Token Expirado',
  transferAmount: 'Valor da Transferência',
  transferFromIt: 'Transferência da Instituição',
  tradingPassword: 'Senha de Negociação',
  transferConfirm: 'Confirmar Transferência',
  transferDetails: 'Detalhes da Transferência',
  transactionModel: 'Modelo de Pagamento',
  transactedAmount: 'Valor da Transação',
  transactionCategory: 'Categoria de Pagamento',
  transferNotifyTimeLimit: 'Limite de Tempo de Notificação da Transferência',

  /* U */
  userId: 'ID do Usuário',
  upload: 'Enviar',
  unitCny: 'CNY',
  username: 'Nome de Usuário',
  unlocked: 'Desbloqueado',
  unverify: 'Não Verificado',
  unchecked: 'Não Verificado',
  unprocess: 'Não Processado',
  uncreated: 'Não Criado',
  unapprove: 'Não Aprovado',
  usCitizen: 'Cidadão dos EUA',
  usResident: 'Residente dos EUA',
  usTaxPayers: 'Contribuinte dos EUA',
  usdFeeAmount: 'Valor da Taxa em USD',
  usBeneficiary: 'Beneficiário dos EUA',
  usCompany: 'Empresa dos EUA',
  unprocessed: 'Não Processado',
  unactivated: 'Não Ativado',
  uploadImage: 'Enviar Imagem',
  uploadProof: 'Enviar Comprovante',
  uploadLimitation: '{types} Tamanho Máximo {maxSize}M',
  upstreamPaymentChannel: 'Canal de Pagamento a Montante',
  unsupportedBrowserTitle: 'Navegador Não Suportado',
  unsupportedBrowserContent1: 'Atualize para o navegador mais recente.',
  unsupportedBrowserContent2: '(Recomendado: Chrome 90+, Safari 14+, Firefox 80+)',

  /* V */
  value: 'Valor',
  verify: 'Verificar',
  verify2: 'Aprovar',
  version: 'Versão',
  validUrl: 'URL Válida',
  verified: 'Verificado',
  verifyId: 'ID de Verificação',
  verifyInfo: 'Informações de Verificação',
  verifyName: 'Nome de Verificação',
  verifyApproval: 'Aprovação de Verificação',
  visibilityHeight: 'Altura de Visibilidade',

  /* W */
  welcome: 'Bem-vindo',
  withdraw: 'Retirar',
  withdrawHistory: 'Histórico de retiradas',
  workflow: 'Fluxo de Trabalho',
  withdrawal: 'Retirada',
  waiverType: 'Tipo de Isenção',
  withdrawalVerify: 'Verificação de Retirada',
  withdrawalAmount: 'Valor da Retirada',
  withdrawalAmountLocal: 'Valor da Retirada (Moeda Local)',
  withdrawApproval: 'Aprovação de Retirada',
  withdrawalDetail: 'Detalhes de Retirada',
  withdrawalFlowId: 'ID de Fluxo de Retirada',
  withdrawalInfo: 'Informações de Retirada',
  windowsDesktop: 'Windows Desktop',
  windowsDesktopLink: 'Link do Aplicativo de Mesa Windows',
  web: 'Trader Web',
  webLink: 'Link do Trader Web',

  /* X */

  /* Y */
  yes: 'Sim',
  youWillTransferForAboveAccountsSeparately: 'Você Transferirá para as Contas Acima Separadamente',

  /* Z */
  cn: 'Chinês Simplificado',

  receiverInfo: 'Informações do beneficiário',
  surNome: 'Sobrenome',
  givNome: 'Nome',
  middleName: 'Nome do meio',
  otherName: 'Nome de outro idioma',
  address: 'Endereço',
  area: 'Código de área do celular',
  phone: 'número de telefone',
  cellphone: 'número de telefone',
  nationality: 'Nacionalidade',
  idType: 'Tipo de documento',
  idNumber: 'Número de identificação',
  locationId: 'ID do local',
  bankId: 'Número da agência bancária',
  bankName: 'Nome da agência bancária',
  bankBranchName: 'Nome da agência',
  bankBranchCode: 'Código da agência',
  bankBranchId: 'ID da agência',
  accountNo: 'Número do cartão bancário',
  occupation: 'Ocupação',
  bankMobile: 'Número de celular reservado pelo banco',
  issueDate: 'Data de emissão do documento',
  expireDate: 'Data de validade do documento',
  licIssuAutho: 'Autoridade emissora do documento',
  remark: 'Observações',
  accountType: 'Tipo de conta',
  city: 'Cidade',
  states: 'Estado',
  zipCode: 'Código postal',
  country: 'País',
  email: 'E-mail',
  accountNumber: 'Número da conta',
  phoneCountry: 'País do número do celular',
  accountCity: 'Cidade onde a conta pertence',
  accountCountry: 'País da conta',
  currency: 'Moeda',
  userName: 'Nome de usuário',
  birthday: 'Data de nascimento',
  postalCode: 'Código postal',
  provinceState: 'Estado/província',
  cardNumber: 'Número do cartão',
  nativeFirstName: 'Sobrenome original',
  nativeLastName: 'Nome original',
  remitterType: 'Tipo de pagamento',
  ibanNo: 'Número de conta bancária internacional',
  accountAddress: 'Endereço da conta',
  routingType: 'Tipo de roteamento',
  senderBusiness: 'Informações da empresa de pagamento',
  registeredName: 'Nome registrado da empresa',
  tradingName: 'Nome da empresa',
  msisdn: 'Número de contato da empresa',
  registrationNumber: 'Número de registro da empresa',
  dateOfIncorporation: 'Data de registro da empresa',
  purposeOfRemittance: 'Finalidade da remessa',
  documentReferenceNumber: 'Número de referência do documento',
  taxId: 'ID fiscal',
  sourceOfFund: 'Fonte de fundos',
  countryCode: 'Código do país',
  transactionType: 'Modo de transação',
  channelCode: 'Número do canal',
  beneficiárioRelationShip: 'Relacionamento de remessa',
  gender: 'Gênero',
  otherDownloads: 'Outros métodos dowloand',
  verifyNotice1: 'Verificação de e‐mail bem-sucedida! ',
  verifyNotice2:
    'Obrigado por registrar no nosso produto---{name}. Agora você pode usar essa conta para fazer login na interface de login. Se você tiver alguma dúvida, sinta-se livre para entrar em contato com nossa equipe de atendimento ao cliente em https://wa.me/13234169593 ',
  verifyNotice3: 'Desejo-lhe um bom uso !',
  depositButtonLabel: 'PIX',
  depositNotice1: 'Dica:',
  depositNotice2: ' na primeira recarga de',
  depositNotice3: '{amount} {currency}',
  depositNotice4: ' a plataforma dará um bônus adicional de',
  depositNotice5: ' {amount} {currency}',
  depositNotice6: 'A taxa de câmbio para depósito e saque é a mesma',
  emailPassword: 'E-mail',
  phonePassword: 'número de telefone',
  globalName: 'ASTRAL',

  cryptoTokenType: 'Rede Blockchain',
  cryptoWalletAddress: 'Endereço da carteira',
};
